import { useEffect, useState } from "react";
import { useSpring } from "framer-motion";

import { getProgress } from "@kikoff/utils/src/number";

namespace useSpringState {
  export type Options = Parameters<typeof useSpring>[1] & {
    valueBounds?: readonly [number, number];
  };
}

function useSpringState(
  value: number,
  { valueBounds, ...options }: useSpringState.Options = {}
) {
  const transform = (v) =>
    valueBounds ? getProgress(valueBounds, v) * 100 : v;
  const reverseTransform = (v) =>
    valueBounds
      ? (v / 100) * (valueBounds[1] - valueBounds[0]) + valueBounds[0]
      : v;
  const progress = transform(value);
  const motionValue = useSpring(progress, {
    damping: 15,
    stiffness: 50,
    ...options,
  });
  const [val, setValue] = useState(motionValue.get());

  useEffect(() => motionValue.onChange(setValue), []);
  useEffect(() => {
    motionValue.set(progress);
  }, [progress]);

  return reverseTransform(val);
}

export default useSpringState;
